/** Store marketing metadata — keep in sync with backend project-modules.store.ts */

export const STORE_MODULE_LISTINGS = [
  {
    code: 'trends',
    tagline: 'Historical charts and trend storage for every tag',
    taglineUk: 'Історичні графіки та зберігання трендів для кожного тега',
    category: 'monitoring',
    sortOrder: 10,
    animationKey: 'trends',
    highlights: ['Per-station charts', 'Configurable retention', 'Project-wide views'],
    highlightsUk: ['Графіки по станціях', 'Налаштовуване зберігання', 'Огляд по всьому проєкту'],
    tutorialSteps: [
      'Enable trend collection in project settings',
      'Open any station and switch to the Trends tab',
      'Pick tags and time range — charts update in realtime',
    ],
    tutorialStepsUk: [
      'Увімкніть збір трендів у налаштуваннях проєкту',
      'Відкрийте станцію та перейдіть на вкладку «Тренди»',
      'Оберіть теги та період — графіки оновлюються в реальному часі',
    ],
    price: { monthly: 29, currency: 'USD' },
  },
  {
    code: 'telegram',
    tagline: 'Instant alerts to your Telegram channel or group',
    taglineUk: 'Миттєві сповіщення у ваш Telegram-канал або групу',
    category: 'integrations',
    sortOrder: 20,
    animationKey: 'telegram',
    highlights: ['Bot token setup', 'Test notifications', 'Per-UID routing'],
    highlightsUk: ['Налаштування токена бота', 'Тестові сповіщення', 'Маршрутизація по UID'],
    tutorialSteps: [
      'Create a bot via @BotFather and paste the token',
      'Add the bot to your channel and configure chat ID',
      'Send a test message to verify delivery',
    ],
    tutorialStepsUk: [
      'Створіть бота через @BotFather і вставте токен',
      'Додайте бота до каналу та вкажіть chat ID',
      'Надішліть тестове повідомлення для перевірки',
    ],
    price: { monthly: 19, currency: 'USD' },
  },
  {
    code: 'telegram_advanced',
    tagline: 'Upgrade Telegram alerts with your own message texts',
    taglineUk: 'Розширення Telegram — власні тексти сповіщень замість стандартних',
    category: 'integrations',
    sortOrder: 21,
    animationKey: 'telegram_advanced',
    highlights: [
      'Requires Telegram notifications addon',
      'Custom alarm open, close, and partial texts',
      'Edit connection lost / restored messages',
      'Live tag tokens and template preview',
    ],
    highlightsUk: [
      'Потрібен базовий модуль Telegram-сповіщень',
      'Власні тексти відкриття, квитування та часткового квитування аварій',
      'Редагування повідомлень про втрату / відновлення звʼязку',
      'Токени тегів і превʼю шаблонів',
    ],
    tutorialSteps: [
      'Enable Telegram notifications (base addon) first',
      'Add Advanced TG in the project store',
      'Open Alarms → Telegram templates and edit your message texts',
    ],
    tutorialStepsUk: [
      'Спочатку підключіть базовий модуль Telegram-сповіщень',
      'Додайте Advanced TG у магазині проєкту',
      'Відкрийте Аварії → Telegram шаблони та змініть тексти повідомлень',
    ],
    price: { monthly: 29, currency: 'USD', note: 'Requires Telegram notifications addon' },
  },
  {
    code: 'svg_hmi',
    tagline: 'Live SVG mimic diagrams on station detail pages',
    taglineUk: 'Живі SVG-мнемосхеми на сторінках станцій',
    category: 'visualization',
    sortOrder: 30,
    animationKey: 'svg_hmi',
    highlights: ['Tag bindings', 'Import from catalog', 'Drill-down layouts'],
    highlightsUk: ['Прив\'язка тегів', 'Імпорт з каталогу', 'Деталізовані макети'],
    tutorialSteps: [
      'Upload or import an SVG config for a UID',
      'Map SVG element IDs to live tags',
      'Attach the config to a project card for runtime display',
    ],
    tutorialStepsUk: [
      'Завантажте або імпортуйте SVG-конфіг для UID',
      'Зв\'яжіть ID елементів SVG із живими тегами',
      'Прикріпіть конфіг до картки проєкту для відображення в runtime',
    ],
    price: { monthly: 49, currency: 'USD' },
  },
  {
    code: 'project_tags',
    tagline: 'Virtual tags scoped to the project, not device catalog',
    taglineUk: 'Віртуальні теги в межах проєкту, поза каталогом пристроїв',
    category: 'monitoring',
    sortOrder: 40,
    animationKey: 'project_tags',
    highlights: ['Computed values', 'Card pseudocode', 'Alarm inputs'],
    highlightsUk: ['Обчислювані значення', 'Псевдокод карток', 'Входи для аварій'],
    tutorialSteps: [
      'Define tag names and data types in Local → Tags',
      'Reference tags in cards and alarm rules',
      'Values update from station data and formulas',
    ],
    tutorialStepsUk: [
      'Задайте імена та типи тегів у Local → Tags',
      'Використовуйте теги в картках та правилах аварій',
      'Значення оновлюються з даних станцій і формул',
    ],
    price: { monthly: 15, currency: 'USD' },
  },
  {
    code: 'project_alarm_rules',
    tagline: 'Configurable alarm rules beyond device defaults',
    taglineUk: 'Налаштовувані правила аварій понад стандарт пристрою',
    category: 'monitoring',
    sortOrder: 50,
    animationKey: 'project_alarm_rules',
    highlights: ['Threshold rules', 'Project-level logic', 'Event history'],
    highlightsUk: ['Порогові правила', 'Логіка на рівні проєкту', 'Історія подій'],
    tutorialSteps: [
      'Open Local → Alarms in the admin panel',
      'Create a rule with conditions on tags or states',
      'Active alarms appear in the operator alarm list',
    ],
    tutorialStepsUk: [
      'Відкрийте Local → Alarms у панелі адміністратора',
      'Створіть правило з умовами на теги або стани',
      'Активні аварії з\'являться у списку оператора',
    ],
    price: { monthly: 25, currency: 'USD' },
  },
  {
    code: 'commands_advanced',
    tagline: 'Command templates and higher priority tiers',
    taglineUk: 'Шаблони команд і розширені рівні пріоритету',
    category: 'operations',
    sortOrder: 60,
    animationKey: 'commands_advanced',
    highlights: ['Template library', 'Priority ceiling 9', 'Catalog tooling'],
    highlightsUk: ['Бібліотека шаблонів', 'Пріоритет до 9', 'Інструменти каталогу'],
    tutorialSteps: [
      'Define command templates for your UIDs',
      'Assign priority tiers to operators',
      'Send commands from station detail with template picker',
    ],
    tutorialStepsUk: [
      'Задайте шаблони команд для ваших UID',
      'Призначте рівні пріоритету операторам',
      'Надсилайте команди зі сторінки станції через вибір шаблону',
    ],
    price: { monthly: 35, currency: 'USD', note: 'Requires Enterprise plan or addon' },
  },
  {
    code: 'maps',
    tagline: 'Geographic map of stations on the groups page',
    taglineUk: 'Географічна карта станцій на сторінці груп',
    category: 'visualization',
    sortOrder: 70,
    animationKey: 'maps',
    highlights: ['MapLibre map', 'Card coordinates', 'Cluster markers'],
    highlightsUk: ['Карта MapLibre', 'Координати з карток', 'Кластерні маркери'],
    tutorialSteps: [
      'Set latitude/longitude on project cards',
      'Open Groups — map tab shows station pins',
      'Click a pin to jump to the station card',
    ],
    tutorialStepsUk: [
      'Вкажіть широту/довготу на картках проєкту',
      'Відкрийте Groups — на вкладці карти з\'являться мітки станцій',
      'Клікніть мітку, щоб перейти до картки станції',
    ],
    price: { monthly: 22, currency: 'USD' },
  },
  {
    code: 'debug_tools',
    tagline: 'Packet inspection and config reload for support',
    taglineUk: 'Перегляд пакетів і перезавантаження конфігу для підтримки',
    category: 'support',
    sortOrder: 80,
    animationKey: 'debug_tools',
    highlights: ['Last packets view', 'Unrecognized frames', 'Force reload'],
    highlightsUk: ['Останні пакети', 'Нерозпізнані кадри', 'Примусове перезавантаження'],
    tutorialSteps: [
      'Open support diagnostics for a station',
      'Inspect recent TCP packets',
      'Trigger config reload without restart',
    ],
    tutorialStepsUk: [
      'Відкрийте діагностику підтримки для станції',
      'Перегляньте останні TCP-пакети',
      'Запустіть перезавантаження конфігу без рестарту',
    ],
    price: { monthly: 0, currency: 'USD', note: 'Included with Enterprise or by request' },
  },
];

/** Quota top-up packages — keep in sync with backend project-modules.store.ts */
export const STORE_QUOTA_PACKAGES = [
  {
    code: 'max_stations',
    label: 'Station limit',
    description: 'Maximum stations across all UIDs in the project',
    valueMode: 'additive',
    sortOrder: 10,
    options: [
      { value: 10, label: '+10 stations', priceMonthly: 15 },
      { value: 25, label: '+25 stations', priceMonthly: 35 },
      { value: 50, label: '+50 stations', priceMonthly: 65 },
      { value: null, label: 'Unlimited', priceMonthly: 120 },
    ],
  },
  {
    code: 'max_users',
    label: 'User seats',
    description: 'Maximum tenant users in the project',
    valueMode: 'additive',
    sortOrder: 20,
    options: [
      { value: 10, label: '+10 users', priceMonthly: 10 },
      { value: 25, label: '+25 users', priceMonthly: 22 },
      { value: 50, label: '+50 users', priceMonthly: 40 },
      { value: null, label: 'Unlimited', priceMonthly: 75 },
    ],
  },
  {
    code: 'alarm_retention_days',
    label: 'Event history retention',
    description:
      'How long project events (alarms, state changes, operator actions) are stored. Plan tier is included; only longer windows are sold here.',
    valueMode: 'absolute',
    planLocked: true,
    sortOrder: 30,
    options: [
      { value: 7, label: '7 days', priceMonthly: 5 },
      { value: 30, label: '30 days', priceMonthly: 12 },
      { value: 90, label: '90 days', priceMonthly: 25 },
      { value: 365, label: '1 year', priceMonthly: 45 },
    ],
  },
  {
    code: 'trend_max_tags',
    label: 'Trend tags in history',
    description:
      'Number of distinct tags that may write trend samples. Billed separately from retention days. Plan includes 10; add tag packs on top.',
    valueMode: 'additive',
    sortOrder: 40,
    options: [
      { value: 10, label: '+10 tags', priceMonthly: 12 },
      { value: 25, label: '+25 tags', priceMonthly: 28 },
      { value: 50, label: '+50 tags', priceMonthly: 48 },
      { value: 100, label: '+100 tags', priceMonthly: 85 },
    ],
  },
  {
    code: 'trend_retention_days',
    label: 'Trend history retention',
    description:
      'How long trend samples are kept. Plan tier is included; only longer retention can be purchased (tag count is separate).',
    valueMode: 'absolute',
    planLocked: true,
    sortOrder: 41,
    options: [
      { value: 30, label: '30 days', priceMonthly: 8 },
      { value: 90, label: '90 days', priceMonthly: 18 },
      { value: 180, label: '180 days', priceMonthly: 32 },
      { value: 365, label: '1 year', priceMonthly: 48 },
      { value: null, label: 'Unlimited', priceMonthly: 55 },
    ],
  },
  {
    code: 'command_priority_ceiling',
    label: 'Command priority ceiling',
    description: 'Maximum command priority tier available to operators',
    valueMode: 'absolute',
    planLocked: true,
    sortOrder: 50,
    options: [
      { value: 6, label: 'Priority up to 6', priceMonthly: 10 },
      { value: 9, label: 'Priority up to 9', priceMonthly: 20 },
    ],
  },
];

/** Base monthly subscription per plan — keep in sync with backend project-modules.store.ts */
export const STORE_PLAN_PRICES = {
  starter: { monthly: 49, currency: 'USD' },
  pro: { monthly: 149, currency: 'USD' },
  enterprise: { monthly: 399, currency: 'USD' },
  legacy_full: {
    monthly: 0,
    currency: 'USD',
    note: 'Legacy projects — no base subscription fee',
  },
};

const LISTING_BY_CODE = Object.fromEntries(
  STORE_MODULE_LISTINGS.map((l) => [l.code, l]),
);

export function getStoreListing(moduleCode) {
  return LISTING_BY_CODE[moduleCode] || null;
}

/** Merge catalog listing with frontend metadata and apply EN/UK text fields. */
export function localizeStoreListing(listing, lang = 'en') {
  if (!listing) return null;
  const base = getStoreListing(listing.code) || {};
  const merged = { ...base, ...listing };
  if (lang !== 'uk') return merged;
  return {
    ...merged,
    tagline: merged.taglineUk || merged.tagline,
    highlights: merged.highlightsUk || merged.highlights,
    tutorialSteps: merged.tutorialStepsUk || merged.tutorialSteps,
  };
}

export function formatListingPrice(listing, locale) {
  const monthly = listing?.price?.monthly;
  if (monthly === 0) return locale?.onRequest || 'On request';
  if (monthly == null) return '—';
  return `$${monthly}${locale?.perMonth || '/ mo'}`;
}
